import { render } from "./AccountOrder.vue?vue&type=template&id=452c1521&scoped=true"
import script from "./AccountOrder.vue?vue&type=script&lang=js"
export * from "./AccountOrder.vue?vue&type=script&lang=js"

import "./AccountOrder.vue?vue&type=style&index=0&id=452c1521&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452c1521"]])

export default __exports__